export default __webpack_public_path__ + "static/media/Jude-Dsouza.a1fa536a.png";